import advancedSearchTemplate from './advancedSearch.html';

function directive() {
  return {
    restrict: 'E',
    scope: {
      count: '=',
      filterSet: '='
    },
    template: advancedSearchTemplate,
    controller: 'advancedSearchController'
  };
}

function advancedSearchController($scope, $translate, _) {
  const ctrl = this;

  $scope.typeaheadConfigs = {
    editable: false,
    selectOnExact: false,
    selectOnBlur: true,
    focusOnSelect: false
  };

  $scope.advancedSearchParamTypes = {
    slug: {
      type: 'slug',
      label: $translate.instant('SLUG')
    },
    headline: {
      type: 'headline',
      label: $translate.instant('HEADLINE')
    },
    sourceId: {
      type: 'sourceId',
      label: $translate.instant('SOURCE_ID')
    },
    tags: {
      type: 'tags',
      label: $translate.instant('TAGS')
    },
    author: {
      type: 'author',
      label: $translate.instant('AUTHOR_NAME')
    },
    authorID: {
      type: 'authorID',
      label: $translate.instant('AUTHOR_ID')
    }
  };

  ctrl.resetDropdown = () => {
    const filtersModel = $scope.filtersModel;
    const params = $scope.advancedSearchParamTypes;

    $scope.availableSearchParamTypes = _.filter(params, (type, typeName) => {
      if (typeName === 'authorID' || typeName === 'tags') {
        return true;
      }

      const filInterface = filtersModel[typeName];

      if (!filInterface.value.length) {
        return true;
      }

      return false;
    });

    // set the param dropdown value to the topmost available param
    const newParamType = $scope.availableSearchParamTypes[0].type;
    $scope.param = {
      type: newParamType,
      value: null
    };
  };

  ctrl.FilterInterface = function FilterInterface(filterObject, displayValCallback) {
    this.displayValCallback = displayValCallback;
    this.filter = filterObject;

    const filterValue = angular.copy(filterObject.value);
    this.value = this.buildInterfaceValue(filterValue);
  };

  ctrl.FilterInterface.prototype.buildInterfaceValue = function buildInterfaceVal(currentVal) {
    const value = currentVal ? [].concat(currentVal) : null;
    const result = [];
    const buildFn = this.buildValueObj.bind(this);

    if (!value) {
      return [];
    }

    value.forEach((val) => {
      result.push(buildFn(val));
    });

    return result;
  };

  ctrl.FilterInterface.prototype.buildValueObj = function buildValObj(val) {
    const value = _.isString(val) ? val.trim() : val;
    const callback = this.displayValCallback;
    let label;

    if (callback) {
      label = callback(value);
    }

    return new ctrl.ValueObj(value, label);
  };

  ctrl.FilterInterface.prototype.setWatch = function setWatcher() {
    const watchString = `filtersModel.${this.filter.name}.filter.value`;
    const buildFn = this.buildInterfaceValue.bind(this);

    const that = this;
    $scope.$watch(watchString, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        that.value = buildFn(newValue);
      }
    });
  };

  ctrl.FilterInterface.prototype.addValue = function addVal(value) {
    const interFaceValue = this.buildValueObj(value);
    this.value.push(interFaceValue);
    this.updateFilter();
  };

  ctrl.FilterInterface.prototype.updateFilter = function updateFil() {
    const filterPayload = this.value.map(valueObj => valueObj.value);

    this.filter.changeValue(filterPayload);
  };

  ctrl.FilterInterface.prototype.deleteValue = function deleteVal(index) {
    this.value.splice(index, 1);
    this.updateFilter();
  };

  ctrl.ValueObj = function ValueObj(value, label) {
    this.value = value;
    this.label = label || value;
  };

  $scope.selectAuthor = ($item) => {
    $scope.authorID = $item.username;
  };

  $scope.selectParam = (paramValue) => {
    $scope.param.value = paramValue;
  };

  $scope.addParam = function addParam() {
    const paramType = $scope.param.type;
    const filInterface = $scope.filtersModel[paramType];

    const value = paramType === 'authorID' ? $scope.authorID : $scope.param.value;

    filInterface.addValue(value);

    $scope.authorID = null;
    ctrl.resetDropdown();
  };

  $scope.delete = (type, index) => {
    $scope.filtersModel[type].deleteValue(index);
    ctrl.resetDropdown();
  };

  function setWatch(typeName) {
    $scope.filtersModel[typeName].setWatch();
  }

  function buildInterface(typeName, config) {
    const filter = $scope.filterSet.getFilter(typeName);
    const result = new ctrl.FilterInterface(filter, config.displayValCallback);
    result.header = config.label;
    result.type = typeName;

    return result;
  }

  function interfaceLoop(callback, returnResult) {
    const interfaces = {};

    Object.keys($scope.advancedSearchParamTypes)
      .forEach((typeName) => {
        const paramInterface = $scope.advancedSearchParamTypes[typeName];
        const result = callback(typeName, paramInterface);
        interfaces[typeName] = result;
      });

    if (returnResult) {
      return interfaces;
    }

    return undefined;
  }

  function initInterfaces() {
    $scope.filtersModel = interfaceLoop(buildInterface, true);
    interfaceLoop(setWatch, false);
  }

  initInterfaces();
  ctrl.resetDropdown();
}

const ctrlArr = [
  '$scope',
  '$translate',
  '_',
  advancedSearchController
];

export default function (ngModule) {
  ngModule.directive('advancedSearch', directive);
  ngModule.controller('advancedSearchController', ctrlArr);
}
